import Component from '@ember/component';
import layout from '../../templates/components/one-way-select/option';
export default Component.extend({
  layout,
  tagName: ''
});